/* eslint-disable space-before-function-paren */
/*
 * @Author: Long
 * @Date: 2021-05-09 15:36:57
 * @LastEditors: Long
 * @LastEditTime: 2022-03-01 14:57:51
 */
const service = require('@/assets/js/request')
const env = process.env

class services {
  /**
   * 获取关于我们子栏目
   */
  static getArtivleListByColumnId(target) {
    service.request({
      method: 'POST',
      url: 'getArtivleListByColumnId',
      params: {
        cate_id: target.cate_id,
        columnLimit: target.columnLimit,
        columnPage: target.columnPage,
        limit: target.limit,
        page: target.page
      }
    }).then(res => {
      if (res.code === '2001') {
        for (let i = 0; i < res.data.length; i++) {
          var item = res.data[i]
          if (item.cover_img !== '') {
            item.cover_img = env.IMG_URL + item.cover_img
          }
        }
        target.list = res.data
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }
}

export default services



// WEBPACK FOOTER //
// ./src/components/index/services/services.js